import { render, staticRenderFns } from "./SsrSelection.vue?vue&type=template&id=ebc4ecc8&scoped=true"
import script from "./SsrSelection.vue?vue&type=script&lang=js"
export * from "./SsrSelection.vue?vue&type=script&lang=js"
import style0 from "./SsrSelection.vue?vue&type=style&index=0&id=ebc4ecc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc4ecc8",
  null
  
)

export default component.exports